import api from "./api";

export const emailService = {
  async sendInvitations(data) {
    const response = await api.post("/api/emails/send-invitations", data);
    return response.data;
  },

  async sendAccommodation(data) {
    const response = await api.post("/api/emails/send-accommodation", data);
    return response.data;
  },

  async sendVendorSchedule(weddingId, vendorIds) {
    const response = await api.post("/api/emails/send-vendor-schedule", {
      wedding_id: weddingId,
      vendor_ids: vendorIds,
    });
    return response.data;
  },

  async testEmail(toEmail) {
    const response = await api.post("/api/emails/test-email", null, {
      params: { to_email: toEmail }
    });
    return response.data;
  },
};
